import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../../styles/jss/variables';
const useStyles = makeStyles()((theme, _params) => {
    var _a;
    return ({
        occasionContainer: {
            flex: 1,
            marginBottom: spacing.large,
        },
        occasionList: {
            display: 'flex',
            flexFlow: 'row wrap',
            justifyContent: 'center',
            gap: `${spacing.small}`,
            alignSelf: 'stretch',
            [theme.breakpoints.up('md')]: {
                display: 'grid',
                justifyContent: 'center',
                gap: spacing.medium,
                gridTemplateColumns: `repeat(${((_a = _params === null || _params === void 0 ? void 0 : _params.occasionsCount) !== null && _a !== void 0 ? _a : 0) + 1} , 1fr)`,
            },
            '& button': {
                [theme.breakpoints.down('md')]: {
                    minWidth: '110px',
                },
                minHeight: '72px',
                padding: spacing.xs,
                '& div': {
                    '& span:first-child': {
                        marginBottom: 0,
                    },
                },
            },
        },
        occasionItem: {
            color: theme.isFlyingFlowers ? colors.black[600] : colors.grey.grey6,
        },
        selectDropdown: {
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: theme.isFlyingFlowers ? `${spacing.small} ${spacing.medium}` : '14px 20px',
        },
        iconSize: {
            '& .MuiIcon-root': {
                fontSize: '1.5rem',
            },
        },
        occasionIcon: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            '& span': {
                '&:first-child': {
                    paddingBottom: spacing.xxs,
                },
            },
        },
        occasionLabel: Object.assign({ color: colors.grey.grey6 }, theme.typography.xxs_bold),
        showOccasionsList: {
            display: 'grid',
            gridTemplateColumns: 'repeat(1, 1fr)',
            [theme.breakpoints.up('md')]: {
                gridTemplateColumns: 'repeat(3, 1fr)',
            },
        },
    });
});
export default useStyles;
